import React from 'react';
import renderHTML from 'react-render-html';
import SipCallingPlanItem from '../sip-calling-plan-item/sip-callling-plan-item';
import SipCallingInclusions from '../sip-calling-inclusions/sip-calling-inclusions';
import SipCallingTrunksNumber from '../sip-calling-trunks-number/sip-calling-trunks-number';
import { stripStartingAndEndingPTags,
  validateSipCallingPlan,
  getSipConnectdevice,
} from '../../../ssm-homepage/ssm-homepage.actions';
import {
  SIP_CONNECT_NO_PABX,
  SIP_CONNECT_PABX_NOT_LISTED,
  SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION,
  SIP_CONNECT_PABX_MODEL_NOT_LISTED,
  IAD_DEVICE_425,
  IAD_DEVICE_270,
  IAD_DEVICE_700,
  IAD_DEVICE_NOT_REQUIRED,
  SIP_CALLING_PLAN_SELECT_OPTION,
} from '../../../../app-constants';
import './sip-calling-plan.css';

const SipCallingPlan = (props) => {
  const {
    authorableContent: {
      summaryTitle,
      preSummary,
      postSummary,
      planSelectionQuestion,
      numberOfTrunksLabel,
      gstText,
      callingPlansLable,
      callInclusionsText,
      businessLinePlan,
      businessTrunkPlan,
      optionPlaceholder,
      callingPlanErrorText,
    },
    siteId,
    handleSipInclusionShowAdvanceFeatures,
    sipInclusionShowList,
    handleSipConnectCallingPlanNumberOfTrunks,
    sitesSipConnectNumberOfTrunks,
    sitesSipConnectPabxVendor,
    sitesSipConnectPabxModel,
    inDial,
    ISDN2,
    deviceNotSuitableText425,
    deviceNotSuitableText270,
    deviceNotSuitableText700,
    deviceNotRequired,
    formSubmitted,
  } = props;

  const bodyText = `${renderHTML(stripStartingAndEndingPTags(preSummary))} `;
  const businessLinePlanContent = { ...businessLinePlan, gstText };
  const businessTrunkPlanContent = { ...businessTrunkPlan, gstText };

  const isVendorSelected = vendorKey => (vendorKey !== SIP_CONNECT_NO_PABX &&
    vendorKey !== SIP_CONNECT_PABX_NOT_LISTED && vendorKey !== SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION);

  const deviceRequiredText = () => {
    if ((sitesSipConnectNumberOfTrunks[siteId] !== undefined && sitesSipConnectNumberOfTrunks[siteId] !== SIP_CALLING_PLAN_SELECT_OPTION) &&
      sitesSipConnectPabxVendor[siteId] !== undefined && (!isVendorSelected(sitesSipConnectPabxVendor[siteId]) ||
      (isVendorSelected(sitesSipConnectPabxVendor[siteId]) && sitesSipConnectPabxModel[siteId] !== undefined &&
      sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION))) {
      const device = getSipConnectdevice(sitesSipConnectPabxVendor, sitesSipConnectPabxModel, sitesSipConnectNumberOfTrunks,
        siteId, inDial, ISDN2);
      if (device === IAD_DEVICE_NOT_REQUIRED) {
        return deviceNotRequired;
      } else if (device === IAD_DEVICE_425) {
        return deviceNotSuitableText425;
      } else if (device === IAD_DEVICE_270) {
        return deviceNotSuitableText270;
      } else if (device === IAD_DEVICE_700) {
        return deviceNotSuitableText700;
      }
    }
    return false;
  };

  const SipCallingInclusionsData = (inDial === false) ? businessLinePlan : businessTrunkPlan;
  const SipCallingPlanItemData = (inDial === false) ? businessLinePlanContent : businessTrunkPlanContent;
  const SipCallingTrunksNumberData = () => {
    if (inDial === false && ISDN2 === true) {
      if (sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
      sitesSipConnectPabxModel[siteId] !== undefined && sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_PABX_MODEL_NOT_LISTED) {
        return businessLinePlanContent.trunkOptions;
      }
      return businessLinePlanContent.trunkOptions.filter(option => (option.value <= 8 || option.key === SIP_CALLING_PLAN_SELECT_OPTION));
    } else if (inDial === true && ISDN2 === true) {
      if (sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
      sitesSipConnectPabxModel[siteId] !== undefined && sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_PABX_MODEL_NOT_LISTED) {
        return businessTrunkPlanContent.trunkOptions;
      }
      return businessTrunkPlanContent.trunkOptions.filter(option => (option.value <= 10 || option.key === SIP_CALLING_PLAN_SELECT_OPTION));
    } else if (inDial === true && ISDN2 === false) {
      if (sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
      sitesSipConnectPabxModel[siteId] !== undefined && sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_PABX_MODEL_NOT_LISTED) {
        return businessTrunkPlanContent.trunkOptions;
      }
      return businessTrunkPlanContent.trunkOptions.filter(option => (option.value <= 60 || option.key === SIP_CALLING_PLAN_SELECT_OPTION));
    }
    return false;
  };

  const showTrunkError = () => {
    if (formSubmitted === true &&
      !validateSipCallingPlan(siteId, sitesSipConnectNumberOfTrunks, inDial, ISDN2, sitesSipConnectPabxVendor, sitesSipConnectPabxModel)) {
      return true;
    }
    return false;
  };

  return (
    <div className="sip-connect-calling-plan">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 id="sip-connect-calling-plan-heading" className="sip-connect-calling-plan-heading">{summaryTitle}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0">
          <p className="calling-plan-description">{bodyText}{renderHTML(stripStartingAndEndingPTags(postSummary))}</p>
        </div>
      </div>
      <div className="row table-border">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4 col-sm-12 table-heading">
              {callingPlansLable}
            </div>
            <div className="col-md-8 col-sm-12 padding-text">
              <SipCallingPlanItem
                authorableContent={SipCallingPlanItemData}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4 col-sm-12 table-heading">
              {planSelectionQuestion}
            </div>
            <SipCallingInclusions
              authorableContent={SipCallingInclusionsData}
              callInclusionsText={callInclusionsText}
              handleSipInclusionShowAdvanceFeatures={handleSipInclusionShowAdvanceFeatures}
              sipInclusionShowList={sipInclusionShowList}
            />
          </div>
        </div>
        <SipCallingTrunksNumber
          siteId={siteId}
          sitesSipConnectNumberOfTrunks={sitesSipConnectNumberOfTrunks}
          handleSipConnectCallingPlanNumberOfTrunks={handleSipConnectCallingPlanNumberOfTrunks}
          numberOfTrunksLabel={numberOfTrunksLabel}
          optionPlaceholder={optionPlaceholder}
          trunkOptions={SipCallingTrunksNumberData()}
          errorText={callingPlanErrorText}
          showError={showTrunkError()}
        />
      </div>
      {deviceRequiredText() !== undefined && deviceRequiredText() !== false &&
        <div className="row">
          <div className="col-12 iad-device">
            <span>{deviceRequiredText()}</span>
          </div>
        </div>
      }
    </div>
  );
};

export default SipCallingPlan;
